// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1595":"94309c8d","3867":"e7c657c0","4156":"11d3e358","7028":"11d3e358"}[chunkId] + ".chunk.css";
};